import { BOTTOMPANEL } from "../../actions/dashboard/";

export default function(state = false, action){
  switch (action.type) {
    case BOTTOMPANEL:
    return action.payload;
    default:
  }

  return state;
}
